export const AteDcrConstants = {
	SCENARIO_ANALYSIS_DISCLOSURE: {
		key: 'SCENARIO_ANALYSIS_DISCLOSURE',
		value: 'SCENARIO_ANALYSIS_DISCLOSURE'
	},
	SCENARIO_ANALYSIS_CHART_TITLE: {
		key: 'SCENARIO_ANALYSIS_CHART_TITLE',
		value: 'Scenario Analysis'
	},

	SCENARIO_ANALYSIS_CHART_SUB_TITLE: {
		key: 'SCENARIO_ANALYSIS_CHART_SUB_TITLE',
		value: 'Scenario Analysis SubTitle'
	},

	SCENARIO_ANALYSIS_LEGEND_EQUITY: {
		key: 'SCENARIO_ANALYSIS_LEGEND_EQUITY',
		value: 'Equity'
	},

	SCENARIO_ANALYSIS_LEGEND_FIXED_INCOME: {
		key: 'SCENARIO_ANALYSIS_LEGEND_FIXED_INCOME',
		value: 'Fixed Income'
	},

	SCENARIO_ANALYSIS_LEGEND_MULTI_ASSET: {
		key: 'SCENARIO_ANALYSIS_LEGEND_MULTI_ASSET',
		value: 'Multi Asset'
	},

	SCENARIO_ANALYSIS_LEGEND_ALTERNATIVES: {
		key: 'SCENARIO_ANALYSIS_LEGEND_ALTERNATIVES',
		value: 'Alternatives'
	},
	ALL_PORTFOLIOS: {
		key: 'ALL_PORTFOLIOS',
		value: 'All Portfolios'
	},

	CHART_LINK_TEXT_EXPOSURES_ASSETALLOCATION: {
		key: 'INSIGHT_LINK_TEXT_EXPOSURES_ASSETALLOCATION',
		value: 'More allocation info'
	}
};
